{
  "pages": [
    {
      "name": "Heat Exchanger for Domestic Hot Water production",
      "elements": [
        {
          "type": "panel",
          "name": "Heat Exchanger for Domestic Hot Water production",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "boolean",
              "name": "Control_enabled",
              "title": "Control of heat exhanging enabled?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Commercial hot water info",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "HeatMeter",
          "elements": [
            {
              "type": "boolean",
              "name": "HM_present",
              "title": "Heat meter needed?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "HM_location",
              "visibleIf": "{HM_present} = true",
              "title": "Where is the heat meter placed?",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Forward"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return"
                }
              ]
            },
            {
              "type": "text",
              "name": "HM_address",
              "visibleIf": "{HM_present} = true",
              "isRequired": true,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Heat Meter",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "panel7",
          "elements": [
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "MAGNA3"
                },
                {
                  "value": "TPE",
                  "text": "TPE"
                },
                {
                  "value": "TPE2",
                  "text": "TPE2"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "Alpha",
                  "text": "ALPHA"
                },
                {
                  "value": "UPS",
                  "text": "UPS"
                },
                {
                  "value": "Pump",
                  "text": "Other"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "visibleIf": "{P_type} = \"Magna3\" or {P_type} = \"TPE\" or {P_type} = \"TPE2\" or {P_type} = \"TPE3\"",
              "title": "Enable pump connectivity?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "P_address",
              "visibleIf": "{P_connected} = true",
              "isRequired": false,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Pump"
        },
        {
          "type": "panel",
          "name": "Sensors",
          "elements": [
            {
              "type": "boolean",
              "name": "T_PF_present",
              "visibleIf": "{HM_present} = false",
              "title": "Primary supply side temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PR_present",
              "visibleIf": "{HM_present} = false",
              "title": "Primary side return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_SR_present",
              "title": "Secondary side return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_SF_present",
              "visibleIf": "{Control_enabled} == false",
              "title": "Secondary Forward temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_CR_present",
              "title": "Circulation return temperature",
              "visibleIf": "{P_connected} != true",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Temperature Sensors"
        },
        {
          "type": "panel",
          "name": "panel3",
          "elements": [
            {
              "type": "boolean",
              "name": "Q_SC_present",
              "title": "Flow meter of cold water supply on secondary side",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "Q_SC_address",
              "visibleIf": "{Q_SC_present} = true",
              "isRequired": true,
              "title": "Flow meter address",
              "inputType": "number"
            }
          ],
          "title": "Flow Meter"
        },
        {
          "type": "panel",
          "name": "panel10",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_PF_sensortype",
              "isRequired": true,
              "visibleIf": "{T_PF_present} == true",
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_PF_present} == true",
          "title": "Primary side supply temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel11",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_PR_sensortype",
              "visibleIf": "{T_PR_present} == true",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_PR_present} == true",
          "title": "Primary side return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel2",
          "visibleIf": "{T_SF_present} == true or {Control_enabled} == true",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_SF_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "title": "Secondary flow temperature sensor details"
        },
        {
          "type": "panel",
          "name": "T_SR",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_SR_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_SR_present} == true",
          "title": "Secondary side return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_CR_sensortype",
              "visibleIf": "{T_CR_present} = true",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_CR_present} = true",
          "title": "Circulation return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "Pressure Sensors",
          "elements": [
            {
              "type": "boolean",
              "name": "DP_S_present",
              "title": "Secondary side differential pressure sensor",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "DP_P_present",
              "title": "Primary side differential pressure sensor",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Pressure Sensors"
        },
        {
          "type": "panel",
          "name": "dsPressure",
          "elements": [
            {
              "type": "dropdown",
              "name": "DP_S",
              "title": "Differential pressure sensor",
              "isRequired": true,
              "choices": [
                {
                  "text": "Grundfos DPI 2+T 0-0,6 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_06"
                },
                {
                  "text": "Grundfos DPI 2+T 0-1,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_10"
                },
                {
                  "text": "Grundfos DPI 2+T 0-1,6 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_16"
                },
                {
                  "text": "Grundfos DPI 2+T 0-2,5 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_25"
                },
                {
                  "text": "Grundfos DPI 2+T 0-4,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_40"
                },
                {
                  "text": "Grundfos DPI 2+T 0-6,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_60"
                },
                {
                  "text": "Grundfos DPI 2+T 0-10,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_100"
                },
                {
                  "text": "Grundfos DPI 2+T 0-16,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_160"
                }
              ]
            }
          ],
          "visibleIf": "{DP_S_present} == true",
          "isRequired": true,
          "title": "Secondary side differential pressure sensor details"
        },
        {
          "type": "panel",
          "name": "dpPressure",
          "elements": [
            {
              "type": "dropdown",
              "name": "DP_P",
              "title": "Differential pressure sensor",
              "isRequired": true,
              "choices": [
                {
                  "text": "Grundfos DPI 2+T 0-0,6 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_06"
                },
                {
                  "text": "Grundfos DPI 2+T 0-1,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_10"
                },
                {
                  "text": "Grundfos DPI 2+T 0-1,6 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_16"
                },
                {
                  "text": "Grundfos DPI 2+T 0-2,5 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_25"
                },
                {
                  "text": "Grundfos DPI 2+T 0-4,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_40"
                },
                {
                  "text": "Grundfos DPI 2+T 0-6,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_60"
                },
                {
                  "text": "Grundfos DPI 2+T 0-10,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_100"
                },
                {
                  "text": "Grundfos DPI 2+T 0-16,0 Bar (E)",
                  "value": "SensorGrundfosDPI_2PlusT_0_160"
                }
              ]
            }
          ],
          "visibleIf": "{DP_P_present} == true",
          "isRequired": true,
          "title": "Primary side differential pressure sensor details"
        },
        {
          "type": "panel",
          "name": "pnlControlValve",
          "elements": [
            {
              "type": "boolean",
              "name": "MV_Parallel_Valve_Enabled",
              "title": "Has parallel valve?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "dropdown",
              "name": "MV_positionControl",
              "visibleIf": "{Control_enabled} = true",
              "title": "Valve position control",
              "isRequired": true,
              "choices": [
                {
                  "value": "ModulatingControl",
                  "text": "Modulating"
                },
                {
                  "value": "ThreePointControl",
                  "text": "3-point control"
                },
                {
                  "value": "ModbusRtuControl",
                  "text": "MODBUS RTU"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_ModbusRtuProfile",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\"",
              "title": "Profile",
              "isRequired": true,
              "choices": [
                {
                  "text": "Belimo Energy Valve EV#R1+(K)BAC",
                  "value": "BelimoEnergyValveProfile_EV_RPlus_Bac"
                },
                {
                  "text": "Belimo Energy Valve EV#R2+(K)BAC",
                  "value": "BelimoEnergyValveProfile_EV_R2Plus_Bac"
                }
              ]
            },
            {
              "type": "text",
              "name": "MV_ModbusRtuAddress",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\"",
              "isRequired": true,
              "title": "MODBUS address",
              "inputType": "number"
            },
            {
              "type": "boolean",
              "name": "MV_overrideDefaultModbusRtuSettings",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\"",
              "title": "Override default MODBUS RTU settings?",
              "isRequired": false,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "dropdown",
              "name": "MV_ModbusRtuBaudRate",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\" and MV_overrideDefaultModbusRtuSettings = true",
              "title": "Baud rate",
              "isRequired": true,
              "choices": [
                {
                  "value": "Baud9600",
                  "text": "9600"
                },
                {
                  "value": "Baud19200",
                  "text": "19200"
                },
                {
                  "value": "Baud38400",
                  "text": "38400"
                },
                {
                  "value": "Baud76800",
                  "text": "76800"
                },
                {
                  "value": "Baud115200",
                  "text": "115200"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_ModbusRtuTransmissionFormat",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\" and MV_overrideDefaultModbusRtuSettings = true",
              "title": "Transmission formats",
              "isRequired": true,
              "choices": [
                {
                  "value": "1-8-N-2",
                  "text": "1-8-N-2"
                },
                {
                  "value": "1-8-N-1",
                  "text": "1-8-N-1"
                },
                {
                  "value": "1-8-E-1",
                  "text": "1-8-E-1"
                },
                {
                  "value": "1-8-O-1",
                  "text": "1-8-O-1"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_actuatorPower",
              "visibleIf": "{MV_positionControl} = \"ModulatingControl\" or {MV_positionControl} = \"ModbusRtuControl\"",
              "title": "Power supply",
              "isRequired": true,
              "choices": [
                {
                  "value": "24_24-Voltage^DirectCurrent",
                  "text": "24V DC"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_actuatorPower",
              "visibleIf": "{MV_positionControl} = \"ThreePointControl\"",
              "title": "Power supply",
              "isRequired": true,
              "choices": [
                {
                  "value": "230_230-Voltage^AlternatingCurrent",
                  "text": "230V AC"
                },
                {
                  "value": "24_24-Voltage^DirectCurrent",
                  "text": "24V DC"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_modulationSignal",
              "visibleIf": "{MV_positionControl} = \"ModulatingControl\"",
              "title": "Modulating signal",
              "isRequired": true,
              "choices": [
                {
                  "value": "0_10-Voltage^DirectCurrent",
                  "text": "0-10 V"
                },
                {
                  "value": "0.5_10-Voltage^DirectCurrent",
                  "text": "0.5-10 V"
                },
                {
                  "value": "2_10-Voltage^DirectCurrent",
                  "text": "2-10 V"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "SP_present",
              "visibleIf": "{MV_actuatorPower} = \"24_24-Voltage^DirectCurrent\" and {MV_positionControl} != \"ModbusRtuControl\"",
              "title": "Motor valve feedback sensor available?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "dropdown",
              "name": "MV_controlValveFeedbackType",
              "visibleIf": "{SP_present} = true and {MV_positionControl} != \"ModbusRtuControl\"",
              "title": "Feedback signal",
              "isRequired": true,
              "choices": [
                {
                  "value": "0cl_10-Voltage^DirectCurrent",
                  "text": "0-10 V"
                },
                {
                  "value": "2cl_10-Voltage^DirectCurrent",
                  "text": "2-10 V"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "MV_overrideDefaultValveTravelTime",
              "visibleIf": "{MV_positionControl} = \"ThreePointControl\"",
              "title": "Override default valve travel time (120s)?",
              "isRequired": false,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "ValveTravelTime",
              "visibleIf": "{MV_positionControl} = \"ThreePointControl\" and {MV_overrideDefaultValveTravelTime} = true",
              "title": "How fast does the valve travel from one extreme position to the other (full travel) in seconds?",
              "isRequired": true,
              "inputType": "number",
              "placeHolder": "Travel time in seconds",
              "unit": "s",
              "validators": [
                {
                  "type": "numeric",
                  "minValue": 30,
                  "maxValue": 600
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_valveLocation",
              "title": "Location",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Flow pipe"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return pipe"
                }
              ]
            }
          ],
          "visibleIf": "{Control_enabled} = true",
          "title": "Control Valve and Actuator"
        }
      ]
    }
  ]
}